import { createContext } from "react";
export var AppPropsContext = createContext(null);
